<div class="main" *ngIf="currResultTotal > 0">
  <div class="main_leftBox">
    <div class="fw-bold fs-5 total-records" style="color: #216273">
      Total Records: <span style="color: #216273">{{ currResultTotal }}</span>
    </div>

    <app-button4 buttonText="XLS" (click)="exportExcel('xlsx')"></app-button4>
    <app-button4 buttonText="CSV" (click)="exportExcel('csv')"></app-button4>
  </div>

  <div class="main_rightBox">
    <!-- Columns setting button -->
    <!-- <div class="main_rightBox_settingBtn" (click)="showColumnsSettingDialog()">
        <i class="pi pi-cog"></i>
      </div> -->

    <!-- Filters -->
    <!-- Country Filter -->
    <div class="main_rightBox_filterContainer_countryFilter">
      <p>Country</p>
      <p-dropdown
        [options]="resultCountries"
        [(ngModel)]="selectedSubFilterCountryObj"
        optionLabel="label"
        [filter]="true"
        filterBy="value"
        placeholder="Select a Country"
        (onChange)="sendSelectedSubFilterCounty()"
        appendTo="body"
      >
        <ng-template #selectedItem let-selectedOption>
          <div class="flex items-center gap-2">
            <div>{{ selectedOption.label }}</div>
          </div>
        </ng-template>
        <ng-template let-countryObj #item>
          <div class="flex items-center gap-2">
            <div>{{ countryObj.label }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Company Filter -->
    <div class="main_rightBox_filterContainer_companyFilter">
      <p>Company</p>
      <p-dropdown
        [options]="resultCompanies"
        [(ngModel)]="selectedSubFilterCompanyObj"
        optionLabel="label"
        [filter]="true"
        filterBy="value"
        placeholder="Select a company"
        styleClass="companyDropdown"
        [style]="{ width: '100%' }"
        [panelStyle]="{ width: '400px' }"
        (onChange)="sendSelectedSubFilterCompany()"
        appendTo="body"
      >
        <ng-template #selectedItem let-selectedOption>
          <div class="flex items-center gap-2">
            <div>{{ selectedOption.label }}</div>
          </div>
        </ng-template>
        <ng-template let-companyObj #item>
          <div class="flex items-center gap-2">
            <div>{{ companyObj.label }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div
      class="main_rightBox_filterContainer_resetFilterBtn"
      (click)="resetFilters()"
    >
      <i class="pi pi-sync"></i>
      <!-- <p>Reset</p> -->
    </div>
    <!-- List view and Grid view toggle button -->
    <div class="main_rightBox_toggleBtn">
      <div
        class="main_rightBox_toggleBtn_list"
        [ngStyle]="
          currViewType === 'listView'
            ? { 'background-color': '#216274', color: '#fff' }
            : { 'background-color': '#fff', color: '#216274' }
        "
        (click)="toggleViewType('listView')"
      >
        <i class="pi pi-bars"></i>
        <p>List View</p>
      </div>
      <div
        class="main_rightBox_toggleBtn_grid"
        [ngStyle]="
          currViewType === 'gridView'
            ? { 'background-color': '#216274', color: '#fff' }
            : { 'background-color': '#fff', color: '#216274' }
        "
        (click)="toggleViewType('gridView')"
      >
        <i class="pi pi-th-large"></i>
        <p>Grid View</p>
      </div>
    </div>
  </div>
</div>

<!-- Columns Setting dialog -->
<p-dialog
  [(visible)]="isShowColumnsSettingDialog"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '50vw' }"
  [draggable]="true"
  styleClass="columns-setting-dialog"
>
  <ng-template #header>
    <div class="columnSettingDialogHeadingContainer">
      <p class="columnSettingDialogHeadingContainer_heading">
        Field Setting - (<span>105</span>)
      </p>
      <app-input1></app-input1>
    </div>
  </ng-template>
  <div class="columnSettingDialogBody">
    <!-- <h1>testinggggggggggg</h1> -->
    <p-table [value]="currColumns" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template #header>
        <tr>
          <th style="max-width: 50px">S.No</th>
          <th style="max-width: 200px">Field Name</th>
          <th style="max-width: 150px">Width(px)</th>
          <th style="max-width: 100px; text-align: center">Show/Hide</th>
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-i="rowIndex">
        <tr>
          <td style="max-width: 50px">{{ i + 1 }}</td>
          <td style="max-width: 200px">{{ rowData.header }}</td>
          <td style="max-width: 150px">
            <span>testttttttttt</span>
            <!-- <p-inputnumber
                [(ngModel)]="rowData.columnWidth"
                [allowEmpty]="false"
                [min]="50"
                [max]="1500"  
                [showButtons]="true"
                buttonLayout="horizontal"       
                spinnerMode="horizontal"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
                size="small"
                class="columnWidthSettingBtn"
              >
                <ng-template #incrementbuttonicon>
                  <span class="pi pi-plus"></span>
                </ng-template>
                <ng-template #decrementbuttonicon>
                  <span class="pi pi-minus"></span>
                </ng-template>
              </p-inputnumber> -->
          </td>
          <td style="max-width: 100px; text-align: center">
            @if (rowData.isDisplay == 1) {
            <i class="pi pi-eye" style="font-size: 22px"></i>
            }@else {
            <i class="pi pi-eye-slash" style="font-size: 22px"></i>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template #footer>
    <app-button5 (click)="isShowColumnsSettingDialog = false"></app-button5>
    <app-button6 buttonText="Save"></app-button6>
  </ng-template>
</p-dialog>
